import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetReceivingRequestsRequestedDownloadParams } from '~/types/receive.types';

type TypeGetRequestsRequestedDownloadMutationParams = TypeGetReceivingRequestsRequestedDownloadParams & {
  ownerCode: string;
};

const fetchRequestsRequestedDownload = async ({
  ownerCode,
  ...params
}: TypeGetRequestsRequestedDownloadMutationParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_REQUESTS_REQUESTED_DOWNLOAD}/${ownerCode}/requests/requested/download`,
    {
      params,
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고요청관리] 입고요청 엑셀 다운로드 Mutation Hook
 */
export const useGetRequestsRequestedDownloadMutation = () => {
  return useDownloadMutation(fetchRequestsRequestedDownload);
};
